(function() {
  var $parcel$bundleURL;
  function $parcel$resolve(url) {
    url = parcelRequire.i?.[url] || url;
    if (!$parcel$bundleURL) {
      try {
        throw new Error;
      } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) {
          $parcel$bundleURL = matches[0];
        } else {
          return $parcel$distDir + url;
        }
      }
    }
    return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
  }
  function $parcel$extendImportMap(map) {
    Object.assign(parcelRequire.i ??= {}, map);
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$distDir = "./";
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("7AHPU", function(module, exports) {
    module.exports = parcelRequire("25LKd")($parcel$resolve("2VMr8")).then(() => parcelRequire("cJzMp"));
  });
  parcelRegister("25LKd", function(module, exports) {
    "use strict";
    var $er6Pe = parcelRequire("er6Pe");
    module.exports = $er6Pe(function(bundle) {
      return new Promise(function(resolve, reject) {
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function(script) {
          return script.src === bundle;
        })) {
          resolve();
          return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
          var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
          script.onerror = script.onload = null;
          script.remove();
          reject(error);
        };
        script.onload = function() {
          script.onerror = script.onload = null;
          resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
      });
    });
  });
  parcelRegister("er6Pe", function(module, exports) {
    "use strict";
    var $a828e1abc8fb2e38$var$cachedBundles = {};
    var $a828e1abc8fb2e38$var$cachedPreloads = {};
    var $a828e1abc8fb2e38$var$cachedPrefetches = {};
    function $a828e1abc8fb2e38$var$getCache(type) {
      switch (type) {
       case "preload":
        return $a828e1abc8fb2e38$var$cachedPreloads;

       case "prefetch":
        return $a828e1abc8fb2e38$var$cachedPrefetches;

       default:
        return $a828e1abc8fb2e38$var$cachedBundles;
      }
    }
    module.exports = function(loader, type) {
      return function(bundle) {
        var cache = $a828e1abc8fb2e38$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
          delete cache[bundle];
          throw e;
        });
      };
    };
  });
  var $aa52abd0949a2e6b$exports = {};
  $parcel$extendImportMap({
    "2VMr8": "app.debug.25859cc5.js"
  });
  var $370e21801f3a2c26$export$2e2bcd8739ae039 = (async () => {
    const {createLogger: createLogger} = await parcelRequire("7AHPU");
    const log = createLogger("details-disclosure");
    if (customElements.get("details-disclosure")) return;
    class DetailsDisclosure extends HTMLElement {
      #details;
      #summary;
      #content;
      #isAnimating=false;
      #isInitiallyOpen=false;
      constructor() {
        super();
        this.#details = this.querySelector("details");
        this.#summary = this.querySelector("summary");
        this.#content = this.querySelector("details > *:not(summary):not([data-close-parent])");
        if (!this.#details || !this.#summary) {
          console.error("[DetailsDisclosure] Component must have a <details> and <summary> element.");
          return;
        }
        this.#isInitiallyOpen = this.#details.hasAttribute("open");
      }
      connectedCallback() {
        this.#summary.addEventListener("click", this.#onSummaryClick);
        this.addEventListener("click", this.#onComponentClick);
        if (this.isOpen) document.addEventListener("click", this.#onBodyClick);
      }
      disconnectedCallback() {
        this.#summary.removeEventListener("click", this.#onSummaryClick);
        this.removeEventListener("click", this.#onComponentClick);
        document.removeEventListener("click", this.#onBodyClick);
      }
      get isOpen() {
        return this.#details?.hasAttribute("open") || false;
      }
      #onSummaryClick=event => {
        event.preventDefault();
        this.isOpen ? this.close() : this.open();
      };
      #onComponentClick=event => {
        const closeButton = event.target.closest("[data-close]");
        const closeParentButton = event.target.closest("[data-close-parent]");
        if (closeButton) {
          event.preventDefault();
          this.close();
        } else if (closeParentButton) this.#closeParentDetails(event);
      };
      #onBodyClick=event => {
        log("ui", "Body click event:", event.target);
        if (this.getAttribute("data-click-outside-close") === "false") {
          log("ui", "Click-outside-close disabled, skipping");
          return;
        }
        const isInsideDetails = event.composedPath().includes(this.#details);
        if (!isInsideDetails) {
          log("ui", "Click outside details detected, closing");
          this.close();
        } else log("ui", "Click inside details component, ignoring");
      };
      #closeParentDetails=event => {
        const parentDetails = event.target.closest("details");
        event.stopPropagation();
        event.preventDefault();
        if (parentDetails !== this.#details) return;
        const isNested = this.#details.closest("details") !== null;
        if (isNested && !this.hasAttribute("data-scroll-lock") && !this.hasAttribute("data-menu")) this.close(false); else this.close();
      };
      async open() {
        if (this.isOpen) return;
        log("ui", "Opening disclosure");
        this.#isAnimating = true;
        this.#details.setAttribute("open", "");
        this.#summary.setAttribute("aria-expanded", "true");
        this.#toggleBodyClasses(true);
        document.addEventListener("click", this.#onBodyClick);
        await this.#waitForAnimations();
        this.#isAnimating = false;
        this.#isInitiallyOpen = false;
        window.dispatchEvent(new CustomEvent("details:toggle", {
          detail: {
            open: true
          }
        }));
      }
      async close(shouldToggleBodyClasses = true) {
        if (!this.isOpen || this.#isAnimating) return;
        log("ui", "Closing disclosure");
        this.#isAnimating = true;
        this.#summary.setAttribute("aria-expanded", "false");
        const finishedAnimations = await this.#waitForAnimations(true);
        this.#details.removeAttribute("open");
        this.#summary.focus();
        if (shouldToggleBodyClasses) this.#toggleBodyClasses(false);
        document.removeEventListener("click", this.#onBodyClick);
        if (finishedAnimations.length > 0) for (const animation of finishedAnimations) {
          const element = animation.effect.target;
          element.style.animation = "none";
          element.offsetHeight;
          element.style.animation = "";
        }
        this.#isAnimating = false;
        window.dispatchEvent(new CustomEvent("details:toggle", {
          detail: {
            open: false
          }
        }));
      }
      async #waitForAnimations(isClosing = false) {
        const elementsToAnimate = [ this.#summary, this.#content ].filter(Boolean);
        await new Promise(resolve => requestAnimationFrame(resolve));
        const animations = elementsToAnimate.flatMap(el => el.getAnimations());
        if (animations.length === 0) return [];
        for (const animation of animations) if (isClosing) animation.reverse(); else {
          animation.currentTime = 0;
          animation.play();
        }
        await Promise.all(animations.map(animation => animation.finished));
        return animations;
      }
      #toggleBodyClasses(isOpening) {
        const selectors = "details-disclosure, nav-details";
        if (this.hasAttribute("data-scroll-lock")) {
          const othersOpen = Array.from(document.querySelectorAll(selectors)).some(el => el !== this && el.hasAttribute("data-scroll-lock") && (el.isOpen || el.hasAttribute("open")));
          if (isOpening) document.documentElement.classList.add("overflow-clip", "overflow-hidden"); else if (!othersOpen) document.documentElement.classList.remove("overflow-clip", "overflow-hidden");
        }
      }
    }
    customElements.define("details-disclosure", DetailsDisclosure);
  })();
})();